import { Component, Input, OnInit } from '@angular/core'

@Component({
    selector: 'app-list-item',
    templateUrl: './list-item.component.html',
})
export class ListItemComponent implements OnInit {

    @Input() iconSrc?: string
    @Input() title!: string
    @Input() subtitle!: string
    @Input() subtitleIcon?: string
    @Input() description?: string
    @Input() descriptionIcon?: string
    @Input() styleVariant: 'primary' | 'secondary' = 'primary'
    @Input() badgeText?: string | null
    @Input() badgeVariant: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark' = 'secondary'

    constructor() { }

    ngOnInit() { }
}
